import apiClient from '../../lib/api-client';
import type { ApiResponse } from '../../types/models';
import type { UserInfo } from '../../lib/auth';

interface LoginParams {
  username: string;
  password: string;
}

interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: UserInfo;
}

export async function login(params: LoginParams): Promise<TokenResponse> {
  const { data } = await apiClient.post<ApiResponse<TokenResponse>>('/auth/login', {
    username: params.username,
    password: params.password,
  });
  return data.data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getMe(): Promise<ApiResponse<UserInfo>> {
  const { data } = await apiClient.get<ApiResponse<UserInfo>>('/auth/me');
  return data;
}

export async function getFeishuAuthUrl(): Promise<{ auth_url: string }> {
  const redirectUri = `${window.location.origin}/login`;
  const { data } = await apiClient.get<ApiResponse<{ auth_url: string }>>('/auth/feishu/auth-url', {
    params: { redirect_uri: redirectUri },
  });
  return data.data;
}

export async function getPermissionInfo(): Promise<import('../../types/models').PermissionInfo> {
  const { data } = await apiClient.get<ApiResponse<import('../../types/models').PermissionInfo>>('/auth/permissions');
  return data.data;
}

interface ProfileUpdateParams {
  phone?: string;
  feishu_auto_sync?: number;
}

export async function updateProfile(params: ProfileUpdateParams): Promise<void> {
  await apiClient.put<ApiResponse<null>>('/auth/me/profile', params);
}
